<template>
  <div>
    <div v-if="mode === 'DESIGN'">
      <el-input
        size="medium"
        disabled
        :placeholder="placeholder"
        show-word-limit
        :rows="2"
        type="textarea"
      />
    </div>
    <div v-else>
      <el-input
        size="medium"
        v-model="_value"
        clearable
        :maxlength="255"
        :placeholder="placeholder"
        show-word-limit
        :rows="3"
        type="textarea"
        :readonly="r"
      />
    </div>
  </div>
</template>

<script>
import componentMinxins from "../ComponentMinxins";

export default {
  mixins: [componentMinxins],
  name: "TextareaInput",
  components: {},
  props: {
    value: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: "请输入内容",
    },
    config1: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    _value: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  data() {
    return { r: false };
  },
  mounted() {
    setTimeout(() => {
      if (this.config1) {
        if (
          this.config1.flag == 2 ||
          this.config1.flag == 3 ||
          this.config1.flag == 4
        ) {
          console.log("仅可读仅可读");
          this.r = true;
        } else {
          var perm = this.config1.perm;
          if (perm == "R") {
            this.r = true;
          }
        }
      }
    }, 500);
  },
  methods: {},
};
</script>

<style scoped></style>
